import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { useFeaturedInSectionContext } from "repoV2/pages/sale/contexts/FeaturedInSectionContext";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";
import { useTemplate3Context } from "../../Template3Context";
import styles from "./FeaturedInSection.module.scss";
import commonStyles from "../../common.module.scss";
import Card from "../Card/Card";

const FeaturedInSection = () => {
    const { theme } = useTemplate3Context();
    const { title, hide, featuredInList } = useFeaturedInSectionContext();

    if (hide) return null;
    return (
        <div style={{ background: theme.colors.color6 }}>
            <div
                className={classNames(
                    commonStyles.section,
                    styles.section,
                    commonStyles.maxWidthContainer
                )}
            >
                {title ? (
                    <h2
                        className={classNames(
                            styles.title,
                            "text-center mt-0 mb-0 word-break"
                        )}
                        style={{ color: theme.colors.color4 }}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: title,
                        }}
                    />
                ) : null}

                <div
                    className={classNames(
                        styles.featuredInListContainer,
                        "d-flex flex-wrap justify-content-center"
                    )}
                >
                    {featuredInList.map(i => (
                        <Card
                            className={classNames(
                                "d-flex flex-column align-items-center text-center",
                                styles.featuredInItem
                            )}
                            style={{ background: theme.colors.color7 }}
                            key={i.title}
                        >
                            <ExlyImage
                                fetchWidth={300}
                                src={i.imgSrc}
                                alt={i.title}
                                className={styles.image}
                            />
                        </Card>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FeaturedInSection;
